/* Mara F13 "Complete the set": Dragon Breath, Pine Pollen and Bear Root, one of each, full price (no discount).
   Loaded by assets/mara-home.js (homepage, All extracts) and assets/mara-product.js (product pages).
   1. "Added to your bag" panel: after an add, lists the set products that aren't in the bag yet, each with an Add button.
      Shown only when the bag has 1 or 2 of the 3. While it shows, the one-bottle offer ("Add a dragon for the road?") is hidden.
   2. All extracts page (/collections/all): a "The full set" card with "Add all three".
      F25: the card sits before the gift card, and when the page passes the cut-out photos (data-cut-pine, data-cut-bear,
      data-leaves on .mc-grid) the three bottles stand on the dark roots backdrop, same look as Dragon Breath.
   Product data comes live from Shopify (/products/{handle}.js), so names, prices and photos stay current.
   Copy rule: product type only (no sensation or promise lines), no health claims. */
(() => {
  const CONFIG = {
    panel: true,          // set to false to switch the panel offer off
    card: true,           // set to false to hide the full-set card on All extracts
    heading: 'Complete the set',
    sub: 'One of each',
    done: 'The full set is in your bag.',
    cardHeading: 'The full set',
    cardLine: 'One bottle of each. The spray, the pollen and the root.',
    set: [
      { handle: 'chilcague', also: ['chilcuague-3-pack'], type: 'Chilcuague spray', cut: true },
      { handle: 'pine-pollen-premium-quality-extract', also: ['pine-pollen-3-pack'], type: 'Pine pollen tincture' },
      { handle: 'bear-root-osha', also: ['bear-root-3-pack'], type: 'Osha root tincture' }
    ]
  };

  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const self = document.currentScript && document.currentScript.src;
  const bottleUrl = self ? self.replace(/mara-set\.js/, 'db-f1-bottle.png') : '';
  const esc = (t) => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const shortName = (t) => t.split(' – ')[0].split(' - ')[0];
  const img = (src, w) => src ? (src.startsWith('//') ? 'https:' + src : src) + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
  let currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (x) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  };
  const itemsText = (c) => `${c.item_count} ${c.item_count === 1 ? 'item' : 'items'} in your bag.`;
  const setCount = (n) => document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = n; el.dataset.full = n > 0; });

  /* Product data */
  const getJSON = (h) => fetch(base + 'products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null).catch(() => null);
  const ready = Promise.all(CONFIG.set.map(async (s) => {
    const [p, ...others] = await Promise.all([getJSON(s.handle), ...(s.also || []).map(getJSON)]);
    if (!p) return null;
    const v = p.variants.find(x => x.available) || p.variants[0];
    return {
      ...s, name: shortName(p.title), url: p.url || ('/products/' + s.handle), price: v.price, vid: v.id,
      available: Boolean(p.available && v.available), image: p.featured_image,
      pids: [p.id, ...others.filter(Boolean).map(o => o.id)].map(String)
    };
  })).then(list => (list.every(x => x && x.available) ? list : null));

  async function add(items) {
    const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
    const cart = await fetch(base + 'cart.js').then(r => r.json());
    setCount(cart.item_count);
    if (cart.currency) currency = cart.currency;
    return cart;
  }

  /* Styles */
  const css = `
  .ms{margin-top:16px;padding-top:16px;border-top:1px solid var(--line)}
  .ms[hidden],.ms-i[hidden],.ms-done[hidden],.ms-msg[hidden]{display:none}
  .ms-h{display:flex;align-items:baseline;justify-content:space-between;gap:10px}
  .ms-h strong{font-size:16px;letter-spacing:-.01em}
  .ms-h span{color:var(--soft);font-size:13px}
  .ms-l{list-style:none;margin:10px 0 0;padding:0;display:grid;gap:8px}
  .ms-i{display:grid;grid-template-columns:44px minmax(0,1fr) auto;gap:12px;align-items:center;padding:8px;border-radius:14px;background:var(--bg2);border:1px solid var(--line)}
  .ms-pic{width:44px;height:52px;border-radius:10px;overflow:hidden;background:#e9ede0;display:block}
  .mh-added .ms-pic img,.ms-pic img{width:100%;height:100%;object-fit:cover;mix-blend-mode:multiply}
  .ms-pic.cut{background:radial-gradient(60% 55% at 50% 55%,rgba(207,232,95,.22),transparent 70%),var(--bg3)}
  .mh-added .ms-pic.cut img,.ms-pic.cut img{object-fit:contain;mix-blend-mode:normal;padding:4px 0;transform:rotate(-7deg)}
  .ms-n{font-weight:700;font-size:15px;line-height:1.25;text-decoration:none;display:block}
  .mh-added p.ms-t,.ms-t{color:var(--soft);font-size:13px;font-weight:500;line-height:1.3;display:block}
  .mh .btn.ms-add{min-height:40px;padding:0 18px;font-size:14px}
  .mh-added p.ms-msg,.ms-msg{margin-top:8px;font-size:13px;font-weight:500;color:#ffb4a6}
  .mh-added p.ms-done,.ms-done{margin-top:10px;font-size:14px;font-weight:700;color:var(--lime)}
  .ms-card .img.trio{display:grid;grid-template-columns:repeat(3,1fr);background:#e9ede0;aspect-ratio:auto;min-height:240px}
  .ms-card .trio span{display:block;overflow:hidden}
  .ms-card .trio img{width:100%;height:100%;object-fit:cover;mix-blend-mode:multiply}
  .ms-card .trio .cut{background:radial-gradient(60% 55% at 50% 55%,rgba(207,232,95,.2),transparent 70%),var(--bg3)}
  .ms-card .trio .cut img{object-fit:contain;mix-blend-mode:normal;padding:16px 8px;transform:rotate(-7deg)}
  .ms-card .names{list-style:none;margin:14px 0 0;padding:0;display:flex;flex-wrap:wrap;gap:8px}
  .ms-card .names li{padding:5px 12px;border-radius:999px;border:1px solid var(--line);font-size:13px;font-weight:700}
  @media (min-width:700px){.mc-grid .ms-card{grid-column:1 / -1}}
  .ms-card .img.trio.stage{display:block;position:relative;background:var(--bg3);min-height:240px}
  .ms-card .img.trio.stage .leaves{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:.7;mix-blend-mode:normal}
  .ms-card .img.trio.stage::after{content:"";position:absolute;inset:0;pointer-events:none;background:radial-gradient(30% 45% at 24% 60%,rgba(207,232,95,.2),transparent 70%),radial-gradient(30% 45% at 50% 55%,rgba(242,201,76,.2),transparent 70%),radial-gradient(30% 45% at 76% 60%,rgba(95,227,198,.2),transparent 70%)}
  .ms-card .img.trio.stage .bottle{position:absolute;z-index:1;bottom:9%;height:74%;width:auto;object-fit:contain;mix-blend-mode:normal;filter:drop-shadow(0 30px 40px rgba(0,0,0,.55))}
  .ms-card .img.trio.stage .b1{left:24%;height:62%;transform:translateX(-50%) rotate(-10deg)}
  .ms-card .img.trio.stage .b2{left:50%;z-index:2;transform:translateX(-50%) rotate(-3deg)}
  .ms-card .img.trio.stage .b3{left:76%;transform:translateX(-50%) rotate(6deg)}`;
  const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  const pic = (s, w) => s.cut && bottleUrl
    ? `<span class="ms-pic cut"><img src="${esc(bottleUrl)}" width="44" height="52" alt="" loading="lazy"></span>`
    : `<span class="ms-pic">${s.image ? `<img src="${esc(img(s.image, w))}" width="44" height="52" alt="" loading="lazy">` : ''}</span>`;

  /* 1. Panel */
  let box = null;
  function buildBox(list) {
    const panel = document.querySelector('[data-added]');
    if (!panel) return null;
    const el = document.createElement('div');
    el.className = 'ms'; el.hidden = true;
    el.innerHTML = `<div class="ms-h"><strong>${esc(CONFIG.heading)}</strong><span>${esc(CONFIG.sub)}</span></div>
      <ul class="ms-l">${list.map((s, i) => `<li class="ms-i" data-i="${i}" hidden>${pic(s, 120)}
        <span><a class="ms-n" href="${esc(s.url)}">${esc(s.name)}</a><span class="ms-t">${esc(s.type)} · ${money(s.price)}</span></span>
        <button class="btn ms-add" type="button" data-set-add aria-label="Add ${esc(s.name)} to your bag">Add</button></li>`).join('')}</ul>
      <p class="ms-done" hidden>${esc(CONFIG.done)}</p><p class="ms-msg" role="alert" hidden></p>`;
    const acts = panel.querySelector('.acts');
    panel.insertBefore(el, acts || null);
    el.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-set-add]'); if (!btn) return;
      const s = list[Number(btn.closest('.ms-i').dataset.i)];
      const msg = el.querySelector('.ms-msg');
      btn.setAttribute('aria-busy', 'true'); msg.hidden = true;
      try {
        const cart = await add([{ id: s.vid, quantity: 1 }]);
        const t = panel.querySelector('[data-added-text] span'); if (t) t.textContent = `${s.name} added. ${itemsText(cart)}`;
        const left = paint(list, cart);
        if (!left) el.querySelector('.ms-done').hidden = false;
      } catch (x) { msg.textContent = `${x.message}. Please try again.`; msg.hidden = false; }
      finally { btn.removeAttribute('aria-busy'); }
    });
    return el;
  }
  function paint(list, cart) {
    const inBag = new Set((cart.items || []).map(i => String(i.product_id)));
    let left = 0;
    box.querySelectorAll('.ms-i').forEach(li => {
      const s = list[Number(li.dataset.i)];
      const have = s.pids.some(id => inBag.has(id));
      li.hidden = have; if (!have) left++;
      li.querySelector('.ms-t').textContent = `${s.type} · ${money(s.price)}`;
    });
    return left;
  }
  async function update(cart) {
    if (!CONFIG.panel || !cart) return false;
    if (cart.currency) currency = cart.currency;
    const list = await ready;
    if (!list) return false;
    if (!box) box = buildBox(list);
    if (!box) return false;
    box.querySelector('.ms-done').hidden = true;
    box.querySelector('.ms-msg').hidden = true;
    const left = paint(list, cart);
    const show = left > 0 && left < list.length;
    box.hidden = !show;
    return show;
  }

  /* 2. Full-set card on All extracts */
  async function card() {
    if (!CONFIG.card || !/\/collections\/all\/?$/.test(location.pathname)) return;
    const grid = document.querySelector('.mc-grid'); if (!grid) return;
    const list = await ready; if (!list) return;
    const total = list.reduce((n, s) => n + s.price, 0);
    const el = document.createElement('article');
    el.className = 'mc-card ms-card';
    const g = grid.dataset;
    const cutFor = (s) => s.cut ? bottleUrl : (s.handle === 'pine-pollen-premium-quality-extract' ? g.cutPine : s.handle === 'bear-root-osha' ? g.cutBear : '');
    const stage = g.leaves && list.every(s => cutFor(s));
    const pics = stage
      ? `<div class="img trio stage" aria-hidden="true"><img class="leaves" src="${esc(g.leaves)}" alt="" loading="lazy">${list.map((s, i) => `<img class="bottle b${i + 1}" src="${esc(cutFor(s))}" alt="" loading="lazy">`).join('')}</div>`
      : `<div class="img trio" aria-hidden="true">${list.map(s => s.cut && bottleUrl
        ? `<span class="cut"><img src="${esc(bottleUrl)}" alt="" loading="lazy"></span>`
        : `<span>${s.image ? `<img src="${esc(img(s.image, 500))}" alt="" loading="lazy">` : ''}</span>`).join('')}</div>`;
    el.innerHTML = `${pics}
      <div class="txt"><h3>${esc(CONFIG.cardHeading)}</h3><p>${esc(CONFIG.cardLine)}</p>
        <ul class="names">${list.map(s => `<li>${esc(s.name)}</li>`).join('')}</ul>
        <div class="row"><span class="amt">${money(total)}</span><button class="btn" type="button" data-set-all>Add all three</button></div>
        <p class="ms-msg" role="alert" hidden></p></div>`;
    grid.insertBefore(el, grid.querySelector('[data-mc-last]'));
    el.querySelector('[data-set-all]').addEventListener('click', async (e) => {
      const btn = e.currentTarget; const msg = el.querySelector('.ms-msg');
      btn.setAttribute('aria-busy', 'true'); msg.hidden = true;
      try {
        const cart = await add(list.map(s => ({ id: s.vid, quantity: 1 })));
        const panel = document.querySelector('[data-added]');
        if (!panel) { location.href = base + 'cart'; return; }
        const t = panel.querySelector('[data-added-text] span'); if (t) t.textContent = `The full set. ${itemsText(cart)}`;
        const up = panel.querySelector('[data-upsell]'); if (up) up.hidden = true;
        if (box) box.hidden = true;
        panel.hidden = false;
        setTimeout(() => panel.classList.add('show'), 20);
        setTimeout(() => { panel.classList.remove('show'); setTimeout(() => { panel.hidden = true; }, 400); }, 7000);
      } catch (x) { msg.textContent = `${x.message}. Please try again.`; msg.hidden = false; }
      finally { btn.removeAttribute('aria-busy'); }
    });
  }

  window.MaraSet = { update };
  card();
})();